import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import React, { useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const IndustryLeadingB = () => {
    const { t } = useLang('Delta3MaxSeriesStation.IndustryLeadingB');

    const items = [
        {
            tabLabel: 'AC出力分割',
            tabValue: 'a',
        },
        {
            tabLabel: '停電対策',
            tabValue: 'b',
        },
        {
            tabLabel: '過負荷防止',
            tabValue: 'c',
        },
    ];

    const contentList = [
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1760962288161-vxsv1l-compressed-AC%20%E5%88%86%E8%B7%AF.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1760962288161-vxsv1l-compressed-AC%20%E5%88%86%E8%B7%AF.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1760962319484-wwxf22-compressed-Frame%202094654241.jpg',
            title: t('title_1'),
            desc: t('desc_1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1757578664622/20250911-161332.mp4',
            pad: 'https://websiteoss.ecoflow.com/upload/video/1757578664622/20250911-161332.mp4',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1757578664622/20250911-161332.mp4',
            title: t('title_2'),
            desc: t('desc_2'),
            isVideo: true,
            poster: 'https://websiteoss.ecoflow.com/upload/image/1757579004256/image1515600822.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1756800545157/industry-img-pc-3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1756800545157/industry-img-pc-3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1757378194218/industry-img-m-3.jpg',
            title: t('title_3'),
            desc: t('desc_3'),
        },
    ];

    const [activeItem, setActiveItem] = useState<any>(contentList[0]);

    const toggleItemHandle = (item: EcoTabItemProps, index: number) => {
        setActiveItem(contentList[index]);
    };
    return (
        <section className={`${styles.IndustryLeadingB} GtmModuleData-section`} data-section-id={'IndustryLeadingB'}>
            <div className="industry-bg-wrap">
                <div className="title-box">
                    <h4 className="title">{activeItem.title}</h4>
                    <p className="desc">{activeItem.desc}</p>
                </div>
                <div className="industry-content">
                    <div className={`industry-content-img`}>
                        <EcoImgVideo isOpenLazy isVideo={activeItem.isVideo} pc={activeItem.pc} pad={activeItem.pad} h5={activeItem.h5} loop={true} />
                    </div>
                    <div className={`industry-content-tab`}>
                        <EcoTab onChange={toggleItemHandle} items={items} theme={'white'} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default IndustryLeadingB;
